import {
  YOUTUBE_LIBRARY_FIND_ALL,
  YOUTUBE_LIBRARY_SET_INITIAL_STATE,
  YOUTUBE_LIBRARY_VIEW
} from './youtubeLibraryTypes'


const initialState = {
  data: [],
  pagination: {
    currentpage: 1,
    itemcount: 0,
    pagesize: 10,
    firstpage: '',
    lastpage: '',
    nextpages: [],
    prevpages: [],
    totalpages: 0
  },

  viewResult: false
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case YOUTUBE_LIBRARY_SET_INITIAL_STATE:
      return initialState;
    case YOUTUBE_LIBRARY_FIND_ALL:
      return {
        data: action.payload.data,
        pagination: action.payload.pagination
      }
    case YOUTUBE_LIBRARY_VIEW:
    return {
      ...state,
      viewResult: action.payload.data
    }
    default: return state
  }
}

export default reducer
